import React from "react";

import AccountModal from "../../login/AccountModal";

import "./user-login.m.css";

const UserLoginPage = () => {
  return (
    <div styleName="wrapper">
      <AccountModal isPopup={false} />
    </div>
  );
};

export { UserLoginPage };
